module.exports = __webpack_public_path__ + "img/status.bbcc5f89.svg";